export class TypedResponseError extends Error {
  public errorText: string;
  public errorData: any;
  constructor(errorTextArg: string, errorDataArg?: any) {
    super(errorTextArg);
    this.name = 'TypedResponseError';
    this.errorText = errorTextArg;
    this.errorData = errorDataArg ?? {};
  }
}
